export const config = {
    leadsReportId: "7e1efd9f-b6ef-4a3e-8b0f-33800edec19a",
    workSpaceId: "e015b7fd-a78d-4cef-b5a1-b67a0580dcaf",
    apiUrl: "https://api.powerbi.com/",
    leadsReportIdWithoutFilters: "450fefbc-9050-4eba-8691-c1e5f10eaa91",

    activityReportId: "be921a1d-6800-4169-8693-09a77aceb3f1",
    activityReportIdWithoutFilters: "ed62a2ee-ae35-4d2e-b6db-3db674680cdd",

    campaignReportId: "482e9778-4b5a-4924-8b09-dcb9ed01bab2",
    campaignReportIdWithoutFilters: "abf7bb97-d84b-47d0-b9dd-7bca54aae9cd"
}
